var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoofTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62813 17.0882H2.00718C1.4521 17.0882 1.00323 16.6361 1.00721 16.0811L1.01321 15.2423C1.01714 14.6928 1.46369 14.2494 2.01318 14.2494H5.49766M2.62813 17.0882C2.62813 17.3207 2.64154 18.5776 2.64656 20C2.64852 20.5523 3.09615 21 3.64844 21H20.3667C20.921 21 21.3695 20.5491 21.3667 19.9948L21.3516 17.0882M2.62813 17.0882H21.3516M21.3516 17.0882H21.9868C22.5363 17.0882 22.9829 16.6449 22.9868 16.0954L22.9928 15.2566C22.9968 14.7015 22.5479 14.2494 21.9928 14.2494H18.1564M12.0102 14.2494V9.26471M12.0102 14.2494H15.3071M12.0102 14.2494H8.34687M12.0102 5.35294H4.30398C4.08195 5.35294 4.02525 5.04519 4.23271 4.96607L12.0102 2L19.7876 4.96607C19.9951 5.04519 19.9384 5.35294 19.7163 5.35294H12.0102ZM12.0102 5.35294V9.26471M8.34687 9.26471H12.0102M12.0102 9.26471H15.6734M15.3071 14.2494V11.6435C15.3071 11.4778 15.4415 11.3435 15.6071 11.3435H18.1564M15.3071 14.2494H18.1564M18.1564 11.3435V14.2494M18.1564 11.3435V8.12471M5.49766 8.12471V11.3435M5.49766 14.2494V11.3435M5.49766 14.2494H8.34687M5.49766 11.3435H8.04687C8.21256 11.3435 8.34687 11.4778 8.34687 11.6435V14.2494",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofTop);
export default __webpack_public_path__ + "static/media/roof_top.ea9d635be60286f40fbe39dd3b7fe246.svg";
export { ForwardRef as ReactComponent };